
import React, { useState, useEffect } from 'react';

const Clicker: React.FC = () => {
  const [revenue, setRevenue] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [devs, setDevs] = useState(0);
  const [servers, setServers] = useState(0);
  const [aiAgents, setAiAgents] = useState(0);

  const devCost = Math.floor(10 * Math.pow(1.15, devs));
  const serverCost = Math.floor(100 * Math.pow(1.15, servers));
  const aiCost = Math.floor(1000 * Math.pow(1.15, aiAgents));

  useEffect(() => {
    const timer = setInterval(() => {
      const passiveIncome = (devs * 1) + (servers * 10) + (aiAgents * 100);
      setRevenue(r => r + passiveIncome);
      setTotalRevenue(t => t + passiveIncome);
    }, 1000);
    return () => clearInterval(timer);
  }, [devs, servers, aiAgents]);

  const click = () => {
    setRevenue(r => r + 1);
    setTotalRevenue(t => t + 1);
  };

  return (
    <div className="max-w-md w-full flex flex-col items-center gap-8">
      <div className="text-center">
        <h2 className="text-5xl font-black text-white mb-2">${revenue.toLocaleString()}</h2>
        <p className="text-slate-400">Current Valuation</p>
      </div>

      <button 
        onClick={click}
        className="w-48 h-48 rounded-full bg-gradient-to-br from-pink-500 to-purple-600 shadow-2xl shadow-pink-500/20 active:scale-95 transition-transform flex items-center justify-center text-6xl border-8 border-slate-800"
      >
        🦄
      </button>

      <div className="grid grid-cols-1 gap-4 w-full">
        <button 
          disabled={revenue < devCost}
          onClick={() => { setRevenue(r => r - devCost); setDevs(d => d + 1); }}
          className="flex justify-between items-center p-4 bg-slate-800 rounded-xl border border-slate-700 disabled:opacity-50"
        >
          <div className="text-left">
            <p className="font-bold text-white">Hire Junior Dev (+1/s)</p>
            <p className="text-xs text-slate-400">Total: {devs}</p>
          </div>
          <span className="text-green-400 font-bold">${devCost}</span>
        </button>

        <button 
          disabled={revenue < serverCost}
          onClick={() => { setRevenue(r => r - serverCost); setServers(s => s + 1); }}
          className="flex justify-between items-center p-4 bg-slate-800 rounded-xl border border-slate-700 disabled:opacity-50"
        >
          <div className="text-left">
            <p className="font-bold text-white">Buy Server (+10/s)</p>
            <p className="text-xs text-slate-400">Total: {servers}</p>
          </div>
          <span className="text-green-400 font-bold">${serverCost}</span>
        </button>

        <button 
          disabled={revenue < aiCost}
          onClick={() => { setRevenue(r => r - aiCost); setAiAgents(a => a + 1); }}
          className="flex justify-between items-center p-4 bg-slate-800 rounded-xl border border-slate-700 disabled:opacity-50"
        >
          <div className="text-left">
            <p className="font-bold text-white">Deploy AI (+100/s)</p>
            <p className="text-xs text-slate-400">Total: {aiAgents}</p>
          </div>
          <span className="text-green-400 font-bold">${aiCost}</span>
        </button>
      </div>
    </div>
  );
};

export default Clicker;
